(() => {
  const root = document.querySelector('#vdv-gifts');
  if (!root) return;
  root.querySelectorAll('[data-gift-carousel]').forEach(carousel => {
    const slides = [...carousel.querySelectorAll('.vg-card__slide')];
    const toggle = carousel.querySelector('[data-gift-carousel-toggle]');
    const counter = carousel.querySelector('[data-gift-slide-counter]');
    if (slides.length < 2) return;
    let current = 0;
    let timer;
    const show = index => {
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      current = index;
      slides[current].classList.add('is-active');
      slides[current].removeAttribute('aria-hidden');
      counter.textContent = (current + 1) + ' / ' + slides.length;
    };
    slides.slice(1).forEach(slide => slide.setAttribute('aria-hidden', 'true'));
    const play = () => {
      clearInterval(timer);
      timer = setInterval(() => show((current + 1) % slides.length), 2000);
      toggle.textContent = 'Pausar';
      toggle.setAttribute('aria-label', 'Pausar carrusel');
    };
    const pause = () => {
      clearInterval(timer);
      timer = null;
      toggle.textContent = 'Reproducir';
      toggle.setAttribute('aria-label', 'Reproducir carrusel');
    };
    toggle.addEventListener('click', () => timer ? pause() : play());
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) pause();
    else play();
    document.addEventListener('visibilitychange', () => {
      if (document.hidden && timer) pause();
    });
  });
  const dialog = root.querySelector('.vg-dialog');
  const form = root.querySelector('[data-gift-form]');
  const submit = root.querySelector('[data-gift-submit]');
  const error = root.querySelector('[data-gift-error]');
  let chosen = null;
  root.addEventListener('click', event => {
    const button = event.target.closest('[data-gift-select]');
    if (button) {
      const card = button.closest('.vg-card');
      const input = card.querySelector('[data-gift-quantity]');
      const quantity = Number(input.value);
      const stock = Number(button.dataset.stock);
      const id = Number(button.dataset.variantId);
      if (!Number.isSafeInteger(quantity) || quantity < 1 || (stock > 0 && quantity > stock) || quantity > Number(input.max)) {
        input.setCustomValidity('Revisa la cantidad de cajas disponibles.');
        input.reportValidity();
        return;
      }
      input.setCustomValidity('');
      if (!Number.isSafeInteger(id)) return;
      chosen = { id, quantity, title: button.dataset.productTitle };
      root.querySelector('[data-gift-chosen]').textContent = quantity + ' × ' + chosen.title;
      error.hidden = true;
      error.textContent = '';
      dialog.showModal();
      form.querySelector('input[name="from"]').focus();
    }
    if (event.target.closest('[data-gift-close]')) dialog.close();
  });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (!chosen || !form.reportValidity()) return;
    const fields = new FormData(form);
    const properties = {
      Presentación: 'Regalo',
      De: String(fields.get('from') || '').trim(),
      Para: String(fields.get('to') || '').trim(),
      Mensaje: String(fields.get('message') || '').trim()
    };
    submit.disabled = true;
    submit.textContent = 'Agregando…';
    error.hidden = true;
    try {
      const base = window.Shopify?.routes?.root || '/';
      const response = await fetch(base + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: chosen.id, quantity: chosen.quantity, properties }] })
      });
      if (!response.ok) {
        const details = await response.json().catch(() => ({}));
        throw new Error(details.description || 'No se pudo agregar la caja. Revisa la disponibilidad e inténtalo de nuevo.');
      }
      window.location.assign(base + 'cart');
    } catch (problem) {
      error.textContent = problem.message || 'Ocurrió un problema. Inténtalo de nuevo.';
      error.hidden = false;
      submit.disabled = false;
      submit.textContent = 'Agregar regalo al carrito →';
    }
  });
})();
